const RELOAD_FLAG = "chunk-reload-attempted";

// Reloading here would discard answers that have not autosaved yet.
const RELOAD_BLOCKED_PREFIXES = [
  "/assessment", // also covers /assessment-center/*
  "/new-assessment",
  "/dashboard/homework-exam",
  "/module/exam",
];

export function isReloadBlockedPath(pathname: string): boolean {
  return RELOAD_BLOCKED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

// A real reload loop retries within milliseconds; a later deploy does not.
export const RETRY_WINDOW_MS = 30_000;

export function shouldAttemptReload(lastAttempt: number, now: number): boolean {
  // Non-finite means missing or corrupted storage: treat as never attempted.
  const previous = Number.isFinite(lastAttempt) ? lastAttempt : 0;

  return now - previous >= RETRY_WINDOW_MS;
}

/**
 * Reload to recover from a stale-deploy asset failure: fresh HTML points at the
 * current hashes. Returns false when recovery was refused, so callers can let
 * the error surface instead.
 */
export function reloadOnce(): boolean {
  const now = Date.now();

  try {
    if (isReloadBlockedPath(window.location.pathname)) return false;

    const lastAttempt = Number(window.sessionStorage.getItem(RELOAD_FLAG));

    if (!shouldAttemptReload(lastAttempt, now)) return false;

    window.sessionStorage.setItem(RELOAD_FLAG, String(now));
  } catch {
    // No storage (private mode) means no loop guard, so do not reload at all.
    return false;
  }

  window.location.reload();

  return true;
}
